import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import store from '../store'
import {
  getToken,
  getAgent
} from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 180000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  let token = localStorage.getItem('token');
  // console.log(token)
  if (config.url.substring(0, 4) == 'http') {
    config.baseURL = config.url
    config.url = ''
  } else if (token) {
    // config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers['token'] = token
  }
  // let agentId = getAgent()
  let agentId = 0
  if (localStorage.getItem('agentInfo')) {
    agentId = JSON.parse(localStorage.getItem('agentInfo')).id
  }
  if (agentId > 0) {
    config.headers['Agent-Id'] = agentId
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 200 && response.config.baseURL.indexOf('oss') == -1) {
      Message({
        message: res.msg ? res.msg : '未知错误',
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js